import DebitVoucher from "./DebitVoucher";

export default DebitVoucher;